import {
  Component,
  OnInit,
  Input
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";

import { TransactionStatus } from "../../../../core/model/transaction.status";
import { PaymentsModalComponent } from "../payments-modal/payments-modal.component";
import { AccountService } from "src/app/core/service/account.service";

@Component({
  selector: "app-transactions-modal",
  templateUrl: "./transactions-modal.component.html",
  styleUrls: ["./transactions-modal.component.scss"],
})
export class TransactionsModalComponent implements OnInit {
  constructor(
    public activeModal: NgbActiveModal,
    private activatedRoute: ActivatedRoute,
    public accountService: AccountService,
    
    private modalService: NgbModal
  ) { }

  @Input() public oppId:any;
  @Input() public token:any;
  @Input() public appname:any;
  @Input() public tid:any;
  indicator: boolean = true;
  transactionStatus = TransactionStatus;
  ngOnInit() {
    this.activatedRoute.params.subscribe((res) => {
      this.trxnDetails = {};
      this.isTransactionsLoaded = false;
      this.getTransactionDetails(this.tid);
    });
  }

  isTransactionsLoaded: boolean = false;
  trxnDetails: any = {};
  isTransactionDetailsLoaded: boolean = true;
  getTransactionDetails(id:any) {
    this.trxnDetails = {};
    this.isTransactionDetailsLoaded = false;
    this.isTransactionsLoaded = true;
    this.accountService.getTransactionDetails(id, this.oppId, this.token, this.appname).subscribe(
      (data:any) => {
        this.trxnDetails = JSON.parse(data);

        if (this.trxnDetails?.RevTrxnDetail?.pymt?.RevPymtDetail) {
          this.trxnDetails.RevTrxnDetail.pymt.RevPymtDetail.sort(function (a: any, b: any) {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            return new Date(b.sysDate).getTime() - new Date(a.sysDate).getTime();
          });
        }

        this.isTransactionDetailsLoaded = true;
        this.isTransactionsLoaded = true;
      },
      (error:any) => {
        this.isTransactionDetailsLoaded = true;
        this.isTransactionsLoaded = true;
      }
    );
  }


  openPaymentModal(pid:any,trxn:any) {
    const modalRef = this.modalService.open(PaymentsModalComponent,{ size: 'lg' });
    modalRef.componentInstance.oppId =this.oppId;
    modalRef.componentInstance.token =this.token;
    modalRef.componentInstance.appname =this.appname;
    modalRef.componentInstance.pid =pid;
  }
  searchItem:any=null;
  openTransactionModal(tid:any,trxn:any) {
    const modalRef = this.modalService.open(TransactionsModalComponent,{ size: 'lg' });
    modalRef.componentInstance.oppId =this.oppId;
    modalRef.componentInstance.token =this.token;
    modalRef.componentInstance.appname =this.appname;
    modalRef.componentInstance.tid =tid;
  }

}
